import { Agencia, Nucleo } from 'api/Assessor/evento';

interface FiltrosState {
  listaAgencias: Array<Agencia>;
  listaNucleos: Array<Nucleo>;
  flgTodos: string;
  agencia: string[];
  nucleo: string[];
  quorumAtingidoOrRepresentados: string;
}

type FiltrosActionTypes =
  | 'setAgencia'
  | 'setNucleo'
  | 'setQuorumAtingidoOrRepresentados'
  | 'setListaAgencias'
  | 'setListaNucleos'
  | 'setFlgTodos';

interface FiltrosAction {
  type: FiltrosActionTypes;
  value: any;
}

export const filtrosInitialState: FiltrosState = {
  listaAgencias: [],
  listaNucleos: [],
  agencia: [],
  flgTodos: 'Todos',
  nucleo: [],
  quorumAtingidoOrRepresentados: 'Quórum atingido',
};

export const filtrosReducer = (
  state: FiltrosState,
  action: FiltrosAction
): FiltrosState => {
  switch (action.type) {
    case 'setListaAgencias':
      return { ...state, listaAgencias: action.value || [] };
    case 'setListaNucleos':
      return { ...state, listaNucleos: action.value || [] };
    case 'setAgencia':
      return { ...state, agencia: action.value || [] };
    case 'setNucleo':
      return { ...state, nucleo: action.value || [] };
    case 'setQuorumAtingidoOrRepresentados':
      return { ...state, quorumAtingidoOrRepresentados: action.value };
    case 'setFlgTodos':
      return { ...state, flgTodos: action.value };
    default:
      return state;
  }
};
